import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { GetConversationsListParams } from './request';
import { getConversationsList } from './request';

export const useGetConversationsListQuery = (
  params: GetConversationsListParams,
  settings?: QuerySettings<typeof getConversationsList>
) =>
  useQuery({
    queryKey: ['getConversationsList', params.chatProfileId],
    queryFn: () => getConversationsList({ params, config: settings?.config }),
    ...settings?.options
  });
